import { SelectionBackgroundIcon } from "@phosphor-icons/react";
import { Button, Dropdown, Flex } from "antd";
import { useTranslate } from "@refinedev/core";

export enum ItemPosition {
  background = "background",
  header = "header",
  moveToFront = "moveToFront",
  moveToBack = "moveToBack",
  moveOneLayerForward = "moveOneLayerForward",
  moveOneLayerBack = "moveOneLayerBack",
}

export const Position = ({
  onChange,
  allowHeader = false,
  dropdown = true,
}: {
  onChange: (key: ItemPosition) => void;
  allowHeader?: boolean;
  dropdown?: boolean;
}) => {
  const t = useTranslate();
  const positionMenu = [
    ...(allowHeader
      ? [
          {
            key: ItemPosition.background,
            label: t(
              "components.templates.SettingsToolbar.controls.position.background"
            ),
            onClick: () => onChange(ItemPosition.background),
          },
          {
            key: ItemPosition.header,
            label: t(
              "components.templates.SettingsToolbar.controls.position.header"
            ),
            onClick: () => onChange(ItemPosition.header),
          },
        ]
      : []),
    ...[
      ItemPosition.moveToBack,
      ItemPosition.moveToFront,
      ItemPosition.moveOneLayerBack,
      ItemPosition.moveOneLayerForward,
    ].map((position) => ({
      key: position,
      label: t(
        `components.templates.SettingsToolbar.controls.position.${position}`
      ),
      onClick: () => onChange(position),
    })),
  ];

  return dropdown ? (
    <Dropdown
      menu={{ items: positionMenu }}
      trigger={["click"]}
      getPopupContainer={(triggerNode) =>
        triggerNode.parentElement ?? triggerNode
      }
    >
      <Button
        type="text"
        size="middle"
        icon={<SelectionBackgroundIcon size={22} />}
        style={{
          paddingRight: 3,
          paddingLeft: 3,
          minWidth: 100,
          width: "fit-content",
        }}
      >
        {t("components.templates.SettingsToolbar.controls.position.position")}
      </Button>
    </Dropdown>
  ) : (
    <Flex vertical gap={8}>
      {positionMenu.map((item) => (
        <Button key={item.key} size="small" onClick={() => onChange(item.key)}>
          {item.label}
        </Button>
      ))}
    </Flex>
  );
};
